exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".full-width {\n  width: 85%;\n\n}\n\n.customer-fields {\n  margin: 5px;\n  padding: 5px;\n}\n\n.fieldType_file\n{\n  text-align: right;\n}\n.file-label\n{\n\n  float: right;\n  width: 150px;\n  font-size: 12px;\n  margin: 3px;\n  margin-top: 14px;\n  padding: 3px;\n  text-align: right;\n  color: #606361;\n  margin-left: 14px;\n\n}\n.field-value\n{\n\n  float: right;\n\n}\n.intakefield\n{\n  margin: 2px;\n  padding: 2px;\n  /*border-top: solid 1px #eeeeee80;*/\n  /*max-width: 500px;*/\n}\n\n.tooltip-text\n{\nfont-size: 10px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/intake-form/intake-field.style.css
// module id = 1164
// module chunks = 0